export default "__VITE_ASSET__DLQiKH6___"